import React, { FunctionComponent, useContext, useState } from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';

import { DecisionTreeContext } from './context/decision-tree-context';
import {
  DecisionTreeResultCtaRemodel,
  DecisionTreeResultCtaDivorce,
  DecisionTreeQuestions,
  DecisionTreeResultAccordion
} from './components';
import ArrowStepperExplanation from './icons/arrow-stepper-explanation';

export const DecisionTree: FunctionComponent = () => {
  const [messages] = useState<Record<string, MessageFormatElement[]>>(
    {} as Record<string, MessageFormatElement[]>
  );
  const { currentQuestion, appType } = useContext(DecisionTreeContext);
  return (
    <IntlProvider locale={'nl'} messages={messages} defaultLocale={'nl'}>
      <div className={`grid grid-cols-12 md:p-0`}>
        {!currentQuestion && (
          <div className={`col-span-12 md:col-span-5 relative`}>
            {appType === 'remodel' && <DecisionTreeResultCtaRemodel />}
            {appType === 'divorce' && <DecisionTreeResultCtaDivorce />}
            <div className={`hidden md:block absolute top-0 -right-20`}>
              <ArrowStepperExplanation />
            </div>
          </div>
        )}

        <div className={`col-span-12 ${!currentQuestion ? 'md:col-span-6 md:col-start-7' : ''}`}>
          {currentQuestion ? <DecisionTreeQuestions /> : <DecisionTreeResultAccordion />}
        </div>
      </div>
    </IntlProvider>
  );
};
